export default __webpack_public_path__ + "static/media/pass.21ce62b7.png";